import React from 'react';
import Panel from './Panel.js';
const BaseUpdate = (props) => {
    if (!props.item.update) {
        return null;
    }
    return (React.createElement(Panel, null,
        React.createElement("div", null, props.item.update)));
};
export default BaseUpdate;
//# sourceMappingURL=BaseUpdate.js.map